module.exports = __webpack_public_path__ + "static/media/6.c8a77d02.png";